import { axiosApiInstance } from "../axios";
import axios from "axios";
import type {
  ResetPasswordPayload,
  UnauthenticatedApiResult,
} from "../types/auth";
import type { ApiErrorPayload } from "../types/api";

const defaultHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

/**
 * Unauthenticated POST to API (no Bearer token, no user_id injection).
 */
export async function postForgotPassword(email: string): Promise<UnauthenticatedApiResult> {
  const url = "forgot-password";
  try {
    const response = await axiosApiInstance.post(url, { email }, { headers: defaultHeaders });
    return {
      ok: true,
      status: response.status,
      data: response.data,
    };
  } catch (err: unknown) {
    const res = axios.isAxiosError<ApiErrorPayload>(err) ? err.response : undefined;
    return {
      ok: false,
      status: res?.status,
      data: res?.data,
    };
  }
}

export async function postResetPassword(
  payload: ResetPasswordPayload,
): Promise<UnauthenticatedApiResult> {
  const url = "reset-password";
  try {
    const response = await axiosApiInstance.post(url, payload, {
      headers: defaultHeaders,
    });
    return {
      ok: true,
      status: response.status,
      data: response.data,
    };
  } catch (err: unknown) {
    const res = axios.isAxiosError<ApiErrorPayload>(err) ? err.response : undefined;
    return {
      ok: false,
      status: res?.status,
      data: res?.data,
    };
  }
}
